import React, { useState } from "react";

interface RemarkProps {
  remark?: string;
  onRemarkChange: (remark: string) => void;
  isEditing: boolean;
}

const Remark: React.FC<RemarkProps> = ({ remark, onRemarkChange, isEditing }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div style={{ marginBottom: "16px" }}>
      <label style={{ display: "block", marginBottom: "6px", fontWeight: "600" }}>
        Remark
      </label>

      {/* Textarea */}
      <textarea
        value={remark || ""}
        placeholder="Enter remark (e.g., Demo/Interview Session)"
        onChange={(e) => onRemarkChange(e.target.value)}
        readOnly={!isEditing}
        style={{
          width: "100%",
          minHeight: "80px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          resize: "vertical",
          backgroundColor: isEditing ? "white" : "#f9fafb",
        }}
      />

      {/* View Full Button (only if remark exists) */}
      {remark && (
        <button
          type="button"
          onClick={() => setShowPopup(true)}
          style={{
            marginTop: "8px",
            padding: "6px 12px",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#0369a1",
            color: "white",
            cursor: "pointer",
          }}
        >
          View Full Remark
        </button>
      )}

      {/* Popup Modal */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "600px",
              width: "100%",
            }}
          >
            <h3 style={{ marginBottom: "12px" }}>Full Remark</h3>
            <p style={{ whiteSpace: "pre-wrap" }}>{remark}</p>
            <button
              type="button"
              onClick={() => setShowPopup(false)}
              style={{
                marginTop: "12px",
                padding: "6px 12px",
                borderRadius: "6px",
                border: "none",
                backgroundColor: "#3b82f6",
                color: "white",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Remark;
